var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"unselect",style:(_vm.textStyle),on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"desc-wrapper"},[_c('span',{style:(_vm.descriptionStyle)},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }